import { createFileRoute } from '@tanstack/react-router'

import { LearnerDetailsPanel } from '@/licenses-tree/components/LearnerDetailsPanel'

export const Route = createFileRoute(
  '/company/_management/licenses-structure/$nodeId/learner/$learnerId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <LearnerDetailsPanel />
}
